import * as sdks from '@mint-lib/api-sdk';
import { createFlagsmithInstance } from '@mint-lib/flags';
import {
  FlagsmithProviderProps,
  FlagsmithProviders,
} from '@mint-lib/flags-envs';

import { type MintServiceLocatorAbstractFactoryContext } from '../types.js';

export async function flagsmithAbstractFactory(
  ctx: MintServiceLocatorAbstractFactoryContext,
  name: keyof typeof FlagsmithProviders,
) {
  const providerSettings: FlagsmithProviderProps = FlagsmithProviders[name];
  const client = createFlagsmithInstance();
  const events = await ctx.getOrThrow('flagsmithEvents', name);

  client._trigger = () => {
    events.emit('event');
  };

  client._triggerLoadingState = () => {
    events.emit('loadingEvent');
  };

  const datadogRum = await ctx.getOrThrow('datadog');
  if (providerSettings.hasIdentify) {
    const profileService = await ctx.getOrThrow('profile');

    await client.init({
      environmentID: providerSettings.envID,
      cacheFlags: true,
      // @ts-ignore TS2339: Property 'options' does not exist on type.
      ...(providerSettings.options ?? {}),
      datadogRum: {
        client: datadogRum,
        trackTraits: true,
      },
      identity: profileService.getProfileData()?.ffId,
      traits: providerSettings.hasCompanyTraits
        ? {
            ...(profileService.getRelease()?.selectedVersion === 'v1'
              ? profileService.getCustomTraitsObj()
              : {}),
            cId: profileService.getProfileData()?.profile?.company?.id ?? null,
            releaseVersion:
              profileService.getRelease()?.selectedVersion ?? null,
          }
        : undefined,
    });
    ctx.addEffect(
      profileService.subscribe(() => {
        client.identify(profileService.getProfileData()?.ffId as string);
      }),
    );
    if (providerSettings.hasCompanyTraits) {
      ctx.addEffect(
        profileService.subscribe(() => {
          client.setTraits({
            ...(profileService.getRelease()?.selectedVersion === 'v1'
              ? profileService.getCustomTraitsObj()
              : {}),
            cId: profileService.getProfileData()?.profile?.company?.id ?? null,
            releaseVersion:
              profileService.getRelease()?.selectedVersion ?? null,
          });
        }),
      );
    }
  } else {
    await client.init({
      environmentID: providerSettings.envID,
      cacheFlags: true,
      // @ts-ignore TS2339: Property 'options' does not exist on type.
      ...(providerSettings.options ?? {}),
      datadogRum: {
        client: datadogRum,
        trackTraits: true,
      },
    });
  }

  // if (name === '@myn/guest' || name === '@mint/app') {
  //   sdks.guestApi.provideFlagsmithClient(client);
  // }

  // if (name === '@mint/arm') {
  //   sdks.defaultApi.provideFlagsmithClient(client);
  // }

  return client;
}
